import Axios from 'axios'
import config from './config'

const apiUrls = {
  remote: config.clientsRemoteApiUrl,
  local: config.clientsLocalApiUrl
}

const getClientDetails = async ({ apiSource, apiKeys }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getClientDetails`,
      method: "get"
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting client details"}
  }
}

const getUsers = async ({ apiSource, apiKeys }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getUsers`,
      method: "get"
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting user list"}
  }
}

const saveUser = async ({ apiSource, apiKeys, user }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveUser/${user.user_id}`,
      method: "patch",
      data: {user}
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving user"}
  }
}

const getApiKeys = async ({ apiSource, apiKeys }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getApiKeys`,
      method: "get"
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting api key list"}
  }
}

const saveClientDetails = async ({ apiSource, apiKeys, client }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveClientDetails`,
      method: "patch",
      data: client
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving client details"}
  }
}

const saveClientMainContact = async ({ apiSource, apiKeys, client }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveClientMainContact`,
      method: "patch",
      data: client
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving client contact"}
  }
}

const addApiKey = async ({ apiSource, apiKeys, keyName }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/addApiKey`,
      method: "put",
      data: { keyName }
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error adding client key "}
  }
}


const deleteClientKey = async ({ apiSource, apiKeys, keyId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deleteClientKey/${keyId}`,
      method: "delete"
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error deleting client key"}
  }
}

const setApiKeyStatus = async ({ apiSource, apiKeys, keyId, status }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/setApiKeyStatus/${keyId}/${status}`,
      method: "patch",
      data: {}
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error setting key status"}
  }
}


const addUser = async ({ apiSource, apiKeys, user }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/addUser`,
      method: "put",
      data: user
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error adding user"}
  }
}


const deleteUser = async ({ apiSource, apiKeys, userId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deleteUser/${userId}`,
      method: "delete"
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error deleting user"}
  }
}




const getInvoices = async ({ apiSource, apiKeys }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getInvoices`,
      method: "get"
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting invoices"}
  }
}

const toggleApiKeyAdminAccess = async ({ apiSource, apiKeys, keyId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/toggleApiKeyAdminAccess/${keyId}`,
      method: "patch"
    }

    let result = await callApi({ apiSource, apiKeys, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting invoices"}
  }
}


const callApi = async ({ apiSource, apiKeys, apiMode, options }) => {
  try {
    const mode = apiMode ?? Object.keys(apiKeys)[0]

    if (apiSource === "local") {
      options.headers = {
        'x-api-key': config.localApiKey,
        'Authorization': apiKeys[mode],
        'Content-type': 'application/json',
      }
    } else {
      options.headers = {
        'x-api-key': apiKeys[mode],
        'Content-type': 'application/json',
      }
    }
    
    options.withCredentials = true

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    throw err
  }
}

export {
  //client
  addApiKey,
  addUser,
  deleteClientKey,
  deleteUser,
  getClientDetails,
  getApiKeys,
  getUsers,
  saveClientMainContact,
  saveClientDetails,
  setApiKeyStatus,
  saveUser,
  toggleApiKeyAdminAccess,
  // billing
  getInvoices,
}